import { IconProps } from "../../../lib/types";

const SortIcon: React.FC<IconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13.698"
      height="19.177"
      viewBox="0 0 13.698 19.177"
      className={className}
    >
      <defs></defs>
      <path
        d="M1.184,40.192h11.33a1.182,1.182,0,0,0,.836-2.017L7.687,32.32a1.176,1.176,0,0,0-1.668,0L.347,38.176A1.182,1.182,0,0,0,1.184,40.192Zm11.327,2.739H1.184a1.182,1.182,0,0,0-.836,2.017L6.019,50.8a1.1,1.1,0,0,0,.83.346,1.179,1.179,0,0,0,.836-.347l5.663-5.855A1.181,1.181,0,0,0,12.511,42.932Z"
        transform="translate(0 -31.973)"
      />
    </svg>
  );
};

export default SortIcon;
